module.exports = __webpack_public_path__ + "img/cooperate5.2232f1fa.png";